export const searchThemesFromTechnology = {
    description: '分析したい技術の内容から該当するテーマを探すことができます。テーマ名から詳細を確認できます。',
    filterThemeLabel: 'テーマの絞り込み',
    filterThemePlaceholder: 'キーワードを入力してください',
    filterThemeExample: '入力例 アンモニア、化学繊維など',
    searchTarget: '検索対象',
    clusterName: 'クラスタ名',
    ipcLabel: '技術分類（IPC）ラベル',
    publicationNumber: '公開番号/特許番号',
    searchOption: '検索オプション',
    ipcCodeLabel: '技術分類（IPC）コード',
    ipcCodePlaceholder: '入力してください',
    searchButton: '絞り込みする',
    themeList: 'テーマ一覧',
    sortDescription: '※項目をクリックすると単項目で並べ替えができます。',
    countText: '該当テーマ：',
    countUnit: '件',

    // テーマ一覧のカラム
    category: 'カテゴリ',
    theme: 'テーマ名',
    numberOfClusterName: 'クラスタ名該当件数',
    numberOfIpcLabel: '技術分類（IPC）ラベル該当件数',
    numberOfIpcCode: '技術分類（IPC）コード該当件数',
    numberOfPatent: '特許出願該当件数',

    unSearched: '※テーマをキーワードで絞り込みすると、検索結果が表示されます。',
    analyzedThemeButton: '選択したテーマを分析する'
}
